import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import { SignInArrowIcon } from '../icons/sign-in-arrow-icon'
import { currentCompany, Company } from '../current-company'

export const SSubmitButton = styled.button<{ fortum: boolean }>`
    display: flex;
    min-width: 150px;
    margin: 0 auto;
    padding: 9px 46px;
    border-radius: 16px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border: none;
    transition: 0.2s ease;
    font-size: 15px;
    svg {
        path {
            fill: ${({ fortum, theme }) => (fortum ? theme.fortumTheme.defaultColor : theme.font.successColor)};
        }
    }

    &[disabled],
    &[disabled]:active:not(:hover) {
        background-color: #e6e6e6;
        color: ${({ theme }) => theme.font.lightestColor};

        svg {
            path {
                fill: ${({ theme }) => theme.font.lightestColor};
            }
        }
    }

    &.inverted {
        background-color: #fff;
        color: #000;
    }

    &:hover {
        background-color: ${({ fortum, theme }) =>
            fortum ? theme.fortumTheme.secondaryColor : theme.font.successColor};
        color: #000;

        svg {
            path {
                fill: ${({ fortum, theme }) => (fortum ? theme.fortumTheme.defaultColor : theme.font.lightestColor)};
            }
        }
    }
    &:active,
    &:active:not(:hover) {
        background-color: #d9edd9;
        color: ${({ theme }) => theme.font.darkestColor};

        svg {
            path {
                fill: ${({ fortum, theme }) => (fortum ? theme.fortumTheme.defaultColor : theme.font.lightestColor)};
            }
        }
    }

    &[disabled]:hover {
        svg {
            path {
                fill: ${({ theme }) => theme.font.lightestColor};
            }
        }
        color: ${({ theme }) => theme.font.lightestColor};
        background-color: #e6e6e6;
    }
`

export type SubmitButtonProps = {
    children: React.ReactNode
    className?: ClassName
    style?: React.CSSProperties
    inverted?: boolean
    disabled?: boolean
    loading?: boolean
}

export function SubmitButton({
    children,
    className,
    style,
    inverted,
    disabled,
    loading = false,
}: SubmitButtonProps): React.ReactElement {
    const isFortumDomain = currentCompany === Company.FORTUM
    return (
        <SSubmitButton
            fortum={isFortumDomain}
            className={cn(className, { inverted })}
            style={style}
            data-testid="submitButton"
            type="submit"
            disabled={disabled}
        >
            {children} {!loading && <SignInArrowIcon className="ml-2" />}
            {loading && <FontAwesomeIcon icon={faSpinner} pulse data-testid="spinner" />}
        </SSubmitButton>
    )
}
